__turbopack_context__.v({
  "bar": "JczVbq_bar",
  "countdown": "JczVbq_countdown",
  "dim": "JczVbq_dim",
  "divider": "JczVbq_divider",
  "dot": "JczVbq_dot",
  "dropdown": "JczVbq_dropdown",
  "eyebrow": "JczVbq_eyebrow",
  "hatName": "JczVbq_hatName",
  "legend": "JczVbq_legend",
  "meter": "JczVbq_meter",
  "num": "JczVbq_num",
  "pad": "JczVbq_pad",
  "panel": "JczVbq_panel",
  "place": "JczVbq_place",
  "sheet": "JczVbq_sheet",
  "sheetBody": "JczVbq_sheetBody",
  "standingsHead": "JczVbq_standingsHead",
  "standingsTitle": "JczVbq_standingsTitle",
  "supply": "JczVbq_supply",
  "supplyRow": "JczVbq_supplyRow",
  "yourHat": "JczVbq_yourHat",
  "yourHatRow": "JczVbq_yourHatRow",
  "yourHatText": "JczVbq_yourHatText",
});
